"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var aspect_1 = require("./aspect");
function weave(target, config) {
    if (target.__woven__) {
        return;
    }
    for (var _i = 0, _a = Array.from(aspect_1.AspectRegistry.values()); _i < _a.length; _i++) {
        var aspect = _a[_i];
        aspect.wove(target, config);
    }
    aspect_1.Targets.add({ target: target, config: config });
    target.__woven__ = true;
    return target;
}
exports.weave = weave;
function Wove(config) {
    return function (target) {
        return weave(target, config);
    };
}
exports.Wove = Wove;
